/** Cross-component realtime invalidation (same tab + optional other tabs). */

export const REALTIME_INVALIDATE_EVENT = 'qnaread:realtime-invalidate';
export const REALTIME_UPDATED_EVENT = 'qnaread:realtime-updated';

const CHANNEL_NAME = 'qnaread-realtime';

export function invalidateRealtime(reason = 'mutation') {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(REALTIME_INVALIDATE_EVENT, { detail: { reason, at: Date.now() } }));
  try {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage({ type: 'invalidate', reason, at: Date.now() });
    channel.close();
  } catch {
    /* BroadcastChannel unsupported */
  }
}

export function subscribeRealtimeInvalidate(handler) {
  if (typeof window === 'undefined') return () => {};
  const onLocal = (e) => handler(e.detail);
  window.addEventListener(REALTIME_INVALIDATE_EVENT, onLocal);

  let channel;
  const onBroadcast = (msg) => {
    if (msg?.data?.type === 'invalidate') {
      handler({ reason: msg.data.reason, at: msg.data.at, crossTab: true });
    }
  };
  try {
    channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = onBroadcast;
  } catch {
    channel = null;
  }

  return () => {
    window.removeEventListener(REALTIME_INVALIDATE_EVENT, onLocal);
    if (channel) channel.close();
  };
}

export function notifyRealtimeUpdated(snapshot) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(REALTIME_UPDATED_EVENT, { detail: snapshot }));
}
